var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -210,
    y: 210,
    width: 960,
    height: 540,
    transform: "translate(750 210) rotate(90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 1444",
    x1: -299.25,
    y1: 1818.26,
    x2: 231.12,
    y2: 361.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#826455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#baaaa1",
    stopOpacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "BG"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-273.13,1667.96v-386.63l213.44,213.44-173.5,173.2h-39.94ZM419.69,573.95l-98.61,98.61h248.15l-149.54-98.61ZM283.98,1036.02h326.58v-311h-326.58v311ZM194.34,1241.18H-239.09l216.53,216.53,216.9-216.53ZM-748.4,731.86l422.82,422.82V421.6l-422.82,278.82v31.44ZM-748.4,806.05v823.91l411.95-411.96-411.95-411.95ZM-712.22,1667.96h386.63v-386.63l-386.63,386.63ZM-158.93,1667.96H234.22l-2.32-390.13-390.82,390.13ZM283.98,1188.71h327.49v-100.23h-327.49v100.23ZM-273.13,387v767.67l401.26-401.26v-371.72L-68.47,252.04l-204.66,134.96ZM611.47,1667.96v-125.88l-1.79-300.9h-325.54l2.54,426.78h324.79ZM374.98,544.47l-135.75,135.75c-1.23,1.23-2.33,2.58-3.3,4.03-.41.61-.68,1.27-1.03,1.9-.48.86-.99,1.69-1.38,2.61-.35.85-.55,1.74-.81,2.61-.23.76-.52,1.49-.68,2.28-.34,1.69-.52,3.41-.52,5.14v489.92H-232.98l405.87-405.87c1.23-1.23,2.33-2.58,3.3-4.03.4-.61.68-1.27,1.03-1.9.48-.86.99-1.7,1.38-2.61.35-.85.55-1.73.81-2.61.23-.76.52-1.49.68-2.29.34-1.69.52-3.41.52-5.13v-347.99l194.38,128.18ZM57.88,1089.36c0-27.58-22.36-49.95-49.95-49.95s-49.95,22.36-49.95,49.95,22.36,49.95,49.95,49.95,49.95-22.36,49.95-49.95Z",
    fill: "url(#e)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginShape);
export default __webpack_public_path__ + "static/media/login-shape.5f7bee47fcd5a05ffb485a501351e8d4.svg";
export { ForwardRef as ReactComponent };